import { observer } from "mobx-react-lite";
import CustomControl from "./CustomControl";

function EmptyMapControl({ height }: IEmptyMapControlProps) {
    return (
        <CustomControl>
            <div style={{ marginTop: `${height}px` }}></div>
        </CustomControl>
    );
}

export default observer(EmptyMapControl);

interface IEmptyMapControlProps {
    height: number;
}